<script lang="ts">
  import WorkflowDashboard from '../../WorkflowDashboard.svelte';
  import UnitTopologyView from '../../UnitTopologyView.svelte';
  import CommissioningPanel from '../../CommissioningPanel.svelte';
  import FilesPanel from '../../FilesPanel.svelte';
  import { router, selectEntity, clearEntity } from '$lib/router';
  import { workspaceMode } from '../../../workspaceMode';
  import { zonesQuery } from '$lib/queries/zones';
  import { loadsQuery } from '$lib/queries/loads';
  import { inputDevicesQuery } from '$lib/queries/input_devices';
  import { rcusQuery } from '$lib/queries/rcus';

  const unitZones = zonesQuery();
  const unitLoads = loadsQuery();
  const unitDevices = inputDevicesQuery();
  const unitRcus = rcusQuery();

  function add(type: string) {
    document.dispatchEvent(new CustomEvent('open-add-menu', { detail: { type } }));
  }

  function handleNavigate(detail: { section: string }) {
    const { section } = detail;

    switch (section) {
      case 'zones': {
        const zone = (unitZones.data ?? [])[0];
        if (zone) selectEntity('zone', zone.id);
        else add('zone');
        break;
      }
      case 'loads': {
        const load = (unitLoads.data ?? [])[0];
        if (load) selectEntity('load', load.id);
        else add('load');
        break;
      }
      case 'hardware': {
        const rcu = (unitRcus.data ?? [])[0];
        if (rcu) selectEntity('rcu', rcu.id);
        else add('rcu');
        break;
      }
      case 'keypads': {
        const keypad = (unitDevices.data ?? [])[0];
        if (keypad) selectEntity('keypad', keypad.id);
        else add('keypad');
        break;
      }
      case 'products':
        selectEntity('products', null);
        break;
      case 'overview':
      case 'export':
        document.dispatchEvent(new CustomEvent('open-export-menu'));
        break;
      default:
        clearEntity();
        break;
    }
  }
</script>

<div class="p-3 space-y-4">
  {#if workspaceMode === 'commissioning'}
    <CommissioningPanel />
  {:else}
    <WorkflowDashboard onnavigate={handleNavigate} />

    <details class="border border-border-default rounded">
      <summary class="px-3 py-2 text-sm font-medium text-text-primary cursor-pointer select-none">
        Unit topology
      </summary>
      <div class="border-t border-border-default">
        <UnitTopologyView />
      </div>
    </details>

    {#if router.projectId && router.unitId}
      <details class="border border-border-default rounded">
        <summary
          class="px-3 py-2 text-sm font-medium text-text-primary cursor-pointer select-none"
        >
          Unit files
        </summary>
        <div class="border-t border-border-default p-3">
          <FilesPanel
            projectId={router.projectId}
            unitId={router.unitId}
            emptyLabel="No unit files uploaded"
          />
        </div>
      </details>
    {/if}
  {/if}
</div>
